import { ChevronRight, ChevronLeft } from 'react-feather';

export default function CustomArrow(props) {
  let icon;
  if (props.direction === 'left') {
    icon = <ChevronLeft size={24} color='black' />
  } else {
    icon = <ChevronRight size={24} color='black' />
  }

  return (
    <div className={props.className} onClick={props.onClick}>{icon}</div>
  );
}
